import { TestMethod } from '.prisma/client';
import { Injectable } from '@angular/core';
import { CreateHotToastRef, HotToastService } from '@ngneat/hot-toast';
import { of } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {
  createItemEffect,
  deleteItemEffect,
  loadListEffect,
  updateItemEffect,
} from '../../shared/crud/effects';
import {
  createItem,
  deleteItem,
  loadList,
  updateItem,
} from './test-method.actions';
import { TestMethodRepository } from './test-method.repository';
import { TestMethodService } from './test-method.service';

@Injectable({ providedIn: 'root' })
export class TestMethodEffects {
  constructor(
    private repository: TestMethodRepository,
    private service: TestMethodService,
    private toast: HotToastService
  ) {}

  loadEntities$ = loadListEffect<TestMethod>({
    action: loadList,
    repository: this.repository,
    serviceAction: () => this.service.findAll(),
    toast: this.toast,
  });

  createEntity$ = createItemEffect<TestMethod>({
    action: createItem,
    repository: this.repository,
    serviceAction: (entity) => this.service.create(entity),
    toast: this.toast,
  });

  updateEntity$ = updateItemEffect<TestMethod>({
    action: updateItem,
    repository: this.repository,
    serviceAction: (id, changes) => this.service.update(id, changes),
    toast: this.toast,
  });

  deleteEntity$ = deleteItemEffect<TestMethod>({
    action: deleteItem,
    repository: this.repository,
    serviceAction: (id) => this.service.delete(id),
    toast: this.toast,
  });

  loadEntityById$ = (id: TestMethod['id']) => {
    let toaster: CreateHotToastRef<unknown>;
    return of(id).pipe(
      switchMap((id) => {
        this.repository.updateStatus('item', 'pending');
        environment?.production ||
          (toaster = this.toast.loading(`Загрузка метода исследований`));
        return this.service.findOne(id).pipe(
          tap((entity) => {
            if (!environment?.production) {
              this.toast.success(`Метод исследований загружен`);
            }
            if (entity) {
              this.repository.updateEntity(entity.id, entity);
            }
          }),
          finalize(() => {
            toaster?.close();
          })
        );
      })
    );
  };
}
